import { createContext, useContext } from 'react';
// Context to expose chat data like online stats and unread notification to the parent components.
export var ChatDataExposureContext = createContext(undefined);
export var useChatDataExposureContext = function () {
    var context = useContext(ChatDataExposureContext);
    if (!context) {
        throw new Error('Chat status Context cannot be rendered outside the Navigation component');
    }
    return context;
};
//# sourceMappingURL=index.js.map